import PatientOverviewPAProgress from 'dashboard/templates/views/Patient/PA/PatientOverviewPAProgress';

import status from './status';
import progress from './progress';

// import sixMWT from './six-mwt';
// import weeklySportsGoal from './weekly-sports-goal';
// import dailyActivityGoal from './daily-activity-goal';
// import strengthTraining from './strength-training';

/**
 * Start moving Progress routes
 * @name router.Start-moving-Progress
 */

export default {
  path: 'progress',
  component: PatientOverviewPAProgress,
  name: 'PatientRecordPAProgress',
  redirect: { name: 'PatientRecordPAProgressStatus' },
  meta: {
    // title: 'Patient Record Physical Activity Progress Status',
    // title: t => `${t('patient.patientRecord')} - ${t('screens.startMovingSettingsScreen', 'app_mobile')} - ${t('journeyProgress.progress')} - ${t('journeyBehaviourChangeGoals.status')}`,
    // title: 'Physical Activity - Status',
    title: t => `${t('screens.startMovingSettingsScreen', 'app_mobile')} - ${t('journeyBehaviourChangeGoals.status')}`,
    loggedInOnly: true,
  },
  children: [
    status,
    progress,
    // Note: Release 2.0 scope reduction
    // sixMWT,
    // weeklySportsGoal,
    // dailyActivityGoal,
    // strengthTraining,
  ],
};
